import { breakpoints } from '../../../styles/theme';
import styled from 'styled-components';
import { OrderPanelStyled } from '../OrderPanelStyled';
import media from '../../../styles/media';
import { rem } from 'polished';

export const OrderPanelStyledDS = styled(OrderPanelStyled)`
    background: ${({ theme }) => theme.colors.grey4};
    min-height: ${rem(88)};
    padding: ${rem(16)} 0;

    @media (min-width: ${breakpoints.md}px) {
        min-height: ${rem(112)};
        padding: ${rem(24)} 0;
    }

    .wrapper {
        min-height: ${rem(64)};
    }

    .priceSection {
        .catalogPrice {
            span,
            strong,
            .catalogPriceLabel,
            .catalogPriceAmount {
                font-size: ${rem(14)};
            }
        }
        .price {
            .cashPrice,
            .cashPriceWithoutTax,
            .priceConjunction,
            .monthlyPrice {
                .formatMoney,
                .price {
                    font-size: ${({ theme }) => theme.fontSizes.h5};
                }
                .deposit {
                    .promotionalTextWrapper,
                    .promotionalText {
                        padding-top: ${rem(4)};
                        font-size: ${rem(14)};
                    }
                }
            }

            .vertical {
                svg {
                    height: ${rem(16)};
                    width: ${rem(16)};

                    g {
                        circle,
                        line {
                            stroke: ${({ theme }) => theme.colors.black};
                        }
                    }
                }
            }
        }
    }

    .benefitSection {
        &.desktop {
            border-left: 1px solid ${({ theme }) => theme.colors.grey11};
        }

        .allow-bullet-points {
            padding-left: ${rem(15)};
        }
    }

    .buttonSection {
        border-left: 1px solid ${({ theme }) => theme.colors.grey11};

        .links > button {
            color: ${({ theme }) => theme.colors.black1};
            font-size: ${({ theme }) => theme.fontSizes.h5};
            font-weight: bold;
            display: flex;
            align-items: baseline;

            .icon-wrapper {
                svg > path {
                    fill: ${({ theme }) => theme.colors.black1};
                }
            }

            &:hover,
            &:focus-visible {
                border-color: ${({ theme }) => theme.colors.primary};
                color: ${({ theme }) => theme.colors.primary};
                border: none;

                .icon-wrapper {
                    svg > path {
                        fill: ${({ theme }) => theme.colors.primary};
                    }
                }
            }
        }

        .desktopContactSection {

            .phoneLink {
                color: ${({ theme }) => theme.colors.black2};
            }
        }
    }

    .mobileContactSection {
        padding: ${rem('10px')};
        background: ${({ theme }) => theme.colors.black1};
    }
`;
